import { ResolvedSlug } from "../../../types/ResolvedSlug";
import { Client } from "../Client";
import { APIRequest, APIRequestMethod } from "../APIRequest";

class SlugAPI {
    Resolve(slug: string): Promise<ResolvedSlug> {
        return Client.Request(new APIRequest(APIRequestMethod.GET, `/api/slugs/resolve/${slug}`));
    }
}

export { SlugAPI }